export default __webpack_public_path__ + "static/media/cross-circle.5cb16aa1.svg";